module.exports = __webpack_public_path__ + "assets/apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/apple-touch-icon.png
// module id = 930
// module chunks = 17